<template>
    <div>
        <psi-card-heading
            headingTitle="Charges"
            :indicator="charges.length"
            indicator-color="primary darken-2"
            icon="mdi-calendar-clock"
        >
            <v-switch
                class="my-0"
                hide-details
                label="Show Dismissed"
                v-model="dismissed"
                dark
                color="primary lighten-2"
            ></v-switch>
        </psi-card-heading>
        <v-row justify="end" class="my-2 mr-1">
            <v-btn @click.stop="expandCollapse()">
                <v-icon class="mr-2">{{ expandIcon }}</v-icon>
                {{ expandText }}
            </v-btn>
        </v-row>
        <v-row justify="center" class="px-4 mt-4">
            <v-expansion-panels accordion v-model="panel" multiple>
                <v-expansion-panel
                    v-for="(item, index) in charges"
                    :key="index"
                >
                    <v-expansion-panel-header>
                        {{ item.chargeNumber }}
                        <v-chip
                            small
                            color="primary darken-2"
                            class="text-uppercase mx-2 justify-center"
                            style="max-width: 120px"
                            v-if="$_.has(item, 'disposition.codeCrimeDispType')"
                            >{{
                                $_.get(item, "disposition.codeCrimeDispType")
                            }}</v-chip
                        >
                        {{ item.codeDegree }} -
                        {{ item.description }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <charge-detail :item="item"></charge-detail>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-row>
    </div>
</template>

<script>
export default {
    name: "case-detail-charges",
    components: {
        ChargeDetail: () => import("./ChargeDetail"),
    },
    props: {
        caseDetails: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            panel: [],
            dismissed: true,
        };
    },
    computed: {
        expandIcon() {
            return this.panel.length === 0
                ? "mdi-expand-all"
                : "mdi-collapse-all";
        },
        expandText() {
            return this.panel.length === 0 ? "Expand All" : "Collapse All";
        },
        charges() {
            return this.caseDetails.charges
                .filter((item) => {
                    return this.dismissed
                        ? true
                        : item.dispositions.findIndex(
                              (val) => val.codeCrimeDispType === "Dismissed"
                          ) === -1;
                })
                .map((item) => {
                    return {
                        ...item,
                        disposition:
                            this.$_.get(item, "dispositions", []).length === 0
                                ? {}
                                : {
                                      ...item.dispositions[0],
                                      dispositionDate: item.dispositions[0][
                                          "dispositionDate"
                                      ]
                                          .split(" ")
                                          .shift(),
                                  },
                        offenseDate: item.offenseDate.split(" ").shift(),
                    };
                });
        },
    },
    methods: {
        expandCollapse() {
            this.panel =
                this.panel.length === 0
                    ? this.charges.map((item, index) => {
                          return index;
                      })
                    : [];
        },
    },
};
</script>

<style lang="scss" scoped>
</style>